module.exports = __webpack_public_path__ + "img/topo-brincando-com-os-numeros.dbf2dddf.png";